import { Pipe, PipeTransform } from '@angular/core';
import NumberFormat = Intl.NumberFormat;

@Pipe({
  name: 'removeUniquePipe',
})
export class removeUniquePipe implements PipeTransform {
  transform(items: any, key?: string, second?: any, appendfirst?: any): any {
    if (items) {
      const a = [];
      const b = [];
      let uniq;
      items.forEach(x => {
        // if (x.SportId != 1) // Bu Kod ile futbol olmayanları getir simüle edilebilir

        a.push(x[key]);
      });

      uniq = [...new Set(a)];
      uniq.forEach(x => {
        let data;
        if (appendfirst) {
          data = {
            key1: x + '|' + [appendfirst],
          };
        } else {
          data = {
            key1: x,
          };
        }

        items.forEach(y => {
          y[key] == x ? (data['key2'] = y[second]) : null;
          y[key] == x && y.SportIcon ? (data['count'] = Number(y.SportIcon)) : 0;
          y[key] == x && y.SportId ? (data['sportId'] = y.SportId) : 0;
          y[key] == x && y.SportNameOriginal ? (data['sportNameOriginal'] = y.SportNameOriginal) : '';
        });
        b.push(data);
      });
      return b;
    }
  }
}
